export default function WhatDoesChange() {
  return <section data-section-id="253280" id="corporatevalueproposition" className="bg-primary py-24 md:py-32 lg:py-40 px-6">
      <div className="max-w-5xl mx-auto text-center flex flex-col items-center justify-center gap-8 md:gap-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-secondary uppercase tracking-widest font-default">
          Legalizzazioni Commerciali
        </h2>
        
        <div className="w-24 h-px bg-secondary mb-2 opacity-60"></div>
        
        <p className="text-6xl md:text-8xl lg:text-9xl font-black text-primary-foreground uppercase tracking-tighter font-default leading-none">
          Global Trust.
        </p>
        
        <p className="text-lg md:text-xl lg:text-2xl text-primary-foreground/80 max-w-3xl mx-auto leading-relaxed font-default font-medium">
          Gestiamo le vostre pratiche camera di commercio e la documentazione per l'export con precisione assoluta. Eccellenza operativa per la vostra mobilità internazionale.
        </p>
      </div>
    </section>;
}